import React from 'react';
import CartDisplay from '../../Components/CartDisplay/CartDisplay';
import Navbar from '../../Components/Navbar/Navbar';
export default function CartScreen() {
	return (
		<div>
			<Navbar />
			<CartDisplay />
		</div>
	);
}
